var appendQueryParam = function (url, key, value) {
    if (value === '' || value === null) {
        return url;
    }
    var punctuation = /\?/.test(url) ? '&' : '?';
    var query = encodeURIComponent(key);
    if (value !== undefined && value !== '') {
        query = query.concat('=', encodeURIComponent(value));
    }
    return url + punctuation + query;
};
var appendQueryObject = function (url, queryObject) {
    if (queryObject === null || queryObject === undefined) {
        return url;
    }
    var result = url;
    Object.keys(queryObject).forEach(function (key) {
        var value = queryObject[key];
        if (value === undefined) {
            return;
        }
        result = appendQueryParam(result, key, value);
    });
    return result;
};

export { appendQueryObject, appendQueryParam };
